export default {
  newDesign: true,
  title: "Çocuğunuz için Ücretsiz Matematik Dersi | Kodland",
  downtimeUrl: "https://www.kodland.org/tr",
  parameters: {
    landing_id: "TrQPrM",
    segment: 12,
  },
  startPage: {
    title:
      "Matematik temel bir beceridir. Çocuğunuzun seviyesini öğrenin ve ücretsiz bir ders kazanın.",
    image: {
      url: "/welcome/quiz_turkey_math_active_pk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/quiz_turkey_math_active_mb.png",
      style: {
        width: "100%",
      },
    },
    button: "Seviyeyi Keşfet 🚀",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      title: "Çocuğunuz kaç yaşında?",
      type: "age",
      button: "İleri 🚀",
    },
    2: {
      question: "Çocuğunuz matematik hakkında nasıl hissediyor? 🧮",
      answers: [
        "🥳 Eğlenceli ama bazen zorlayıcı",
        "😊 Fena değil, ama ekstra destek gerekli",
        "😔 Zorlayıcı ve can sıkıcı",
        "😢 Bunaltıcı geliyor",
      ],
    },
    3: {
      question: "Çocuğunuzun matematikteki en büyük hedefi nedir?",
      answers: [
        "📈 Notları yükseltmek ve 'yeni nesil' soruları geçmek",
        "🌟 Odaklanmayı ve özgüveni artırmak",
        "🏫 Lise ve gelecek sınavlar için hazırlık yapmak",
        "🤓 Stresi azaltmak ve matematiği daha kolay anlamak",
      ],
    },
    4: {
      question:
        "Çocuğunuzun matematik ve gelecekteki sınavlar için ekstra desteğe ihtiyacı var mı?",
      answers: [
        "✅ Evet, düzenli desteğe ihtiyaçları var",
        "🤔 Belki, şimdilik idare ediyor ama ekstra yardım iyi olabilir",
        "❌ Hayır, şu anki ilerlemeleriyle gayet iyi gidiyorlar",
      ],
    },
    5: {
      question: "Şu anda sizin için en önemli hedef nedir?",
      answers: [
        "1️⃣ Temel konuları iyi anlamak",
        "2️⃣ Okul notlarını yükseltmek",
        "3️⃣ Daha zor konulara geçmek",
        "4️⃣ Sınavlara hazırlanmak",
      ],
    },
    6: {
      question:
        "Çocuğunuzun çalışması için bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayır",
          stopAnswer: true,
        },
      ],
    },
    7: {
      typeInfo: "loaderScreen",
      sliderImages: [
        "/welcome/tr_math_scholarship_review1_desk.png",
        "/welcome/tr_math_scholarship_review2_desk.png",
        "/welcome/tr_math_scholarship_review3_desk.png",
      ],
      sliderImagesMobile: [
        "/welcome/tr_math_scholarship_review1_mob.png",
        "/welcome/tr_math_scholarship_review2_mob.png",
        "/welcome/tr_math_scholarship_review3_mob.png",
      ],
      textLoader: "%93 kontenjan doldu — acele edin!",
      titleLoader: "Sonuçlarınız hazırlanıyor…",
      subtitleLoader:
        "Çocuğunuz için en uygun matematik seviyesini belirliyoruz.",
      duration: 5000,
    },
    8: {
      dynamicTypeInfo: [
        {
          condition: [{ step: 1, ageMin: 3, ageMax: 6 }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_personalized_quiz_math_final_l1_2.png",
            title: "🧠 Çocuğunuz için en uygun başlangıç matematik seviyesini bulduk | Kodland",
            subtitle: "Çocuğunuz matematiğin temellerini eğlenceli görevlerle öğrenebilir. Programımız sayılar, sayma ve basit problemleri oyun temelli şekilde öğretir.",
            button: "👉 Ücretsiz dersinizi alın",
          },
        },
        {
          condition: [{ step: 1, ageMin: 7, ageMax: 8 }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_personalized_quiz_math_final_l3_4.png",
            title: "🧠 Çocuğunuz için uygun matematik seviyesini belirledik | Kodland",
            subtitle: "Bu seviyede çocuklar geometri, mantık ve veri ile ilgili problemleri keşfeder. Matematik düşünmesini geliştiren eğlenceli görevlerle ilerler.",
            button: "👉 Ücretsiz dersinizi alın",
          },
        },
        {
          condition: [{ step: 1, ageMin: 9, ageMax: 10 }],
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_personalized_quiz_math_final_l5_6.png",
            title: "🧠 Çocuğunuz daha ileri matematik konularına hazır | Kodland",
            subtitle: "Bu seviyede çocuklar aritmetik işlemleri, kesirleri ve daha karmaşık matematik problemlerini öğrenir.",
            button: "👉 Ücretsiz dersinizi alın",
          },
        },
        {
          default: true,
          data: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_personalized_quiz_math_final_l7.png",
            title: "🧠 Çocuğunuz ileri düzey matematik için hazır | Kodland",
            subtitle: "Bu program cebir, geometri ve istatistik gibi daha ileri konuları kapsar ve çocukların analitik düşünmesini geliştirir.",
            button: "👉 Ücretsiz dersinizi alın",
          },
        },
      ],
    },
    9: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    10: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    11: {
      title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    12: {
      title:
        "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    13: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    },
  },
};
